import common from '@/utils/common'
import languageObj from './footer-component-lan.json'
require('./footer-component.scss')
const template = require('./footer-component.tpl')
const { mapState } = require('vuex')
const projectData = require('@/utils/projectData.json')
const hostPath = require('@config/host')

export default {
  template,

  name: 'header-component',

  computed: {
    ...mapState({
      lan: (state) => {
        return state.sys.lan
      }
    })
  },
  data () {
    return {
      LANMSG: {},
      coptyRight: '',
      coptyRecord: '',
      support: ''
    }
  },
  watch: {
    lan: function (n) {
      this.setLanguageMsg(n)
      this.changeLanguageMethod()
    }
  },

  // 实例创建后,进行默认数据处理
  created () {
    this.setLanguageMsg(this.lan)
    this.changeLanguageMethod()
  },

  // html挂载在页面后,进行数据初始化
  mounted () {},

  // 方法集合
  methods: {
    // 设置语言文字
    setLanguageMsg (lan) {
      this.LANMSG = languageObj[lan]
    },

    // 语言改变时
    changeLanguage (val) {
      common.setLanguage(val)
    },
    changeLanguageMethod () {
      if (common.isEnLan()) {
        this.coptyRight = projectData[hostPath.sysType].coptyRightEn
        this.coptyRecord = projectData[hostPath.sysType].coptyRecordEn
        this.support = projectData[hostPath.sysType].supportEn
      } else {
        this.coptyRight = projectData[hostPath.sysType].coptyRight
        this.coptyRecord = projectData[hostPath.sysType].coptyRecord
        this.support = projectData[hostPath.sysType].support
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/footer/footer-component.js